<script>
import appConfig from "@/app.config";
import { BButton } from "bootstrap-vue";
import { auth } from '@/services/index'

export default {
    data() {
        return {
            showBanner: true,
        };
    },
    components: { BButton },
    methods: {
        async acceptCookies(status) {
            localStorage.setItem("cookiesAccepted", status);
            this.showBanner = false;
          	const response = await auth.acceptCookies();
        },
    },
    created() {
        if (localStorage.getItem("cookiesAccepted")) {
            this.showBanner = false;
        }
    },
};
</script>
<template>
    <div v-if="showBanner" class="cookie-banner z-3 px-10 relative">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="17"
            height="17"
            viewBox="0 0 17 17"
            class="x-icon cursor-pointer"
            @click="showBanner = false"
        >
            <defs>
                <clipPath id="clip-path-x">
                    <rect
                        id="Rectangle_18708"
                        data-name="Rectangle 18708"
                        width="17"
                        height="17"
                        transform="translate(-8781.912 -14270.912)"
                        fill="#fff"
                    />
                </clipPath>
            </defs>
            <g
                id="ico_-_exit_-_default"
                data-name="ico - exit - default"
                transform="translate(8781.912 14270.912)"
                clip-path="url(#clip-path)"
            >
                <g
                    id="Group_10855"
                    data-name="Group 10855"
                    transform="translate(-8780.634 -14269.634)"
                >
                    <path
                        id="Path_10354"
                        data-name="Path 10354"
                        d="M18.981,5.25,5.25,18.981"
                        transform="translate(-5.25 -5.25)"
                        fill="none"
                        stroke="#adb5bd"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                    />
                    <path
                        id="Path_10355"
                        data-name="Path 10355"
                        d="M18.981,18.981,5.25,5.25"
                        transform="translate(-5.25 -5.25)"
                        fill="none"
                        stroke="#adb5bd"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                    />
                </g>
            </g>
        </svg>

        <div class="d-flex justify-content-between">
            <div class="title d-flex gap-3 align-items-center">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="24"
                    height="22"
                    viewBox="0 0 24 22"
                >
                    <defs>
                        <clipPath id="clip-path-cookie">
                            <rect
                                id="Rectangle_19802"
                                data-name="Rectangle 19802"
                                width="24"
                                height="22"
                                transform="translate(66 660)"
                                fill="#c0141b"
                                stroke="#c0141b"
                                stroke-width="1"
                            />
                        </clipPath>
                    </defs>
                    <g
                        id="ico_-_cookies_-_default"
                        data-name="ico - cookies - default"
                        transform="translate(-66 -660)"
                        clip-path="url(#clip-path)"
                    >
                        <g
                            id="Group_13369"
                            data-name="Group 13369"
                            transform="translate(65.997 659.007)"
                        >
                            <path
                                id="Path_28038"
                                data-name="Path 28038"
                                d="M21,11.944A9,9,0,1,1,12.056,3a.76.76,0,0,1,.732.919,3,3,0,0,0,2.887,3.656.75.75,0,0,1,.75.75,3,3,0,0,0,3.656,2.888.76.76,0,0,1,.92.73h0Z"
                                fill="none"
                                stroke="#c0141b"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                            />
                            <path
                                id="Path_28039"
                                data-name="Path 28039"
                                d="M14.625,17.625a1.5,1.5,0,1,0-1.5-1.5A1.5,1.5,0,0,0,14.625,17.625Z"
                                fill="#c0141b"
                            />
                            <path
                                id="Path_28040"
                                data-name="Path 28040"
                                d="M8.625,16.875a1.5,1.5,0,1,0-1.5-1.5A1.5,1.5,0,0,0,8.625,16.875Z"
                                fill="#c0141b"
                            />
                            <path
                                id="Path_28041"
                                data-name="Path 28041"
                                d="M7.875,11.625a1.5,1.5,0,1,0-1.5-1.5A1.5,1.5,0,0,0,7.875,11.625Z"
                                fill="#c0141b"
                            />
                            <path
                                id="Path_28042"
                                data-name="Path 28042"
                                d="M12.75,13.125a1.5,1.5,0,1,0-1.5-1.5A1.5,1.5,0,0,0,12.75,13.125Z"
                                fill="#c0141b"
                            />
                        </g>
                    </g>
                </svg>
                <span> This website uses cookies </span>
            </div>
        </div>

        <div class="content mt-6">
            We use cookies to operate this website, improve usability,
            personalized your experience, and improve our marketing. Your
            privacy is important to us, and we will never your data.
            <router-link :to="{ name: 'PrivacyPolicy' }" class="link">
                Privacy Policy.
            </router-link>
        </div>

        <!-- <button @click="acceptCookies">Accept</button> -->
        <div class="d-flex justify-content-end">
            <div class="d-flex gap-3">
                <b-button
                    variant="outline-primary"
                    @click="acceptCookies('true')"
                >
                    Accept all cookies
                </b-button>
                <b-button
                    variant="primary"
                    class="w-lg"
                    @click="acceptCookies('decline')"
                >
                    Decline
                </b-button>
            </div>
        </div>
    </div>
</template>

<style>
.link {
    text-align: left;
    text-decoration: underline !important;
    font: normal normal normal 14px/19px IBM Plex Sans;
    letter-spacing: 0px;
    color: #056ed6;
}
.cookie-banner .x-icon {
    position: absolute;
    top: 27px;
    right: 24px;
}
.cookie-banner .title {
    text-align: left;
    font: normal normal 600 22px/28px IBM Plex Sans;
    letter-spacing: 0px;
    color: #c0141b;
}
.cookie-banner .content {
    margin-top: 24px;
    margin-bottom: 40px;
    text-align: left;
    font: normal normal normal 14px/19px IBM Plex Sans;
    letter-spacing: 0px;
    opacity: 1;
}
.cookie-banner {
    border: 1px solid #ced4da;
    height: 217px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 10px;
    background-color: #ffffff;
    z-index: 5;
    padding: 24px 22px;
}
</style>
